import { CSSProperties, ReactNode } from "react";
import { Box, BoxProps, Heading, Text, useMediaQuery } from "@chakra-ui/react";

import { ChildrenFC } from "src/types/types";
import { BREAK_WIDTHS } from "utils/css/consts";

interface IProps {
  styleProps?: BoxProps;
  title?: ReactNode;
  dataTest?: string;
  blendOnMobile?: boolean;
}

const cssProps: CSSProperties = {
  backgroundColor: "ud-white",
  borderRadius: "8px",
  boxShadow: "0 2px 11px 0 rgba(0, 0, 0, 0.18)",
};

const Card: ChildrenFC<IProps> = ({
  title,
  dataTest,
  children,
  blendOnMobile = false,
  styleProps,
}) => {
  const [isLargerThan992] = useMediaQuery(
    `(min-width: ${BREAK_WIDTHS.desktop}px)`,
  );
  const padding = styleProps?.p ? styleProps.p : "30px 36px";

  const getPadding = () => {
    if (isLargerThan992) {
      return padding;
    }
    if (blendOnMobile) {
      return "unset";
    }

    return padding;
  };

  const getStyle = () => {
    if (isLargerThan992) {
      return cssProps;
    }
    if (blendOnMobile) {
      return undefined;
    }

    return cssProps;
  };

  return (
    <Box
      data-test={dataTest}
      p={getPadding()}
      style={getStyle()}
      {...styleProps}
    >
      {title && (
        <Heading as="h3" mb={2}>
          {title}
        </Heading>
      )}
      <Box>
        {typeof children === "string" ? (
          <Text textAlign="left">{children}</Text>
        ) : (
          children
        )}
      </Box>
    </Box>
  );
};

export default Card;
